<template>
    <EmployeeLink
        :user="user"
        :fallback="fallback"
        :name-order="nameOrder"
        :show-telegram-username="showTelegramUsername"
    />
</template>

<script>
import EmployeeLink from '@/components/EmployeeLink.vue';

export default {
    name: 'TelegramUserLink',
    components: {
        EmployeeLink
    },
    props: {
        user: {
            type: Object,
            default: null
        },
        fallback: {
            type: String,
            default: 'Не указан'
        },
        nameOrder: {
            type: String,
            default: 'first-last'
        },
        showTelegramUsername: {
            type: Boolean,
            default: false
        }
    }
};
</script>
